export default __webpack_public_path__ + "assets/images/1d0e29a1965124cdc4c2d2c428d60577-logo-mercado-pago.png";